<div class="modal-dialog m-0 p-4 document">
    <div class="modal-header p-0 justify-content-between align-items-center border-0 close--icon">
        <img src="assets/images/icons/cross-icon.svg" alt="" class="hw-32 border p-1 cursor rounded-circle"
            (click)="onClose()">
    </div>
    <div class="text-center">
        <img src="assets/images/img/logout.svg" alt="">
        <h2 class="modal-title fs-24 fw-600 mt-3" id="exampleModalLabel">
            Logout
        </h2>
    </div>
    <div class="fs-16 fw-500 modal-body p-0 mt-1 mb-2 text-center">
        Are you sure, you want to logout your account?
    </div>
    <div class="btn-group w-100 mt-3 gap-3">
        <button type="button" class="w-50 btn btn-primary btn-pill fw-600 w-100" (click)="logout()">Yes</button>
        <button type="submit" class="w-50 btn btn-default fw-600 w-100" style="border-radius: 6px !important;"
            (click)="onClose()">Cancel</button>
    </div>
</div>